<template>
  <component :is="component" :value="items" @input="$emit('input',$event)"><!-- value и input для draggable component-->
    <template v-for="(item,index) in items" >
      <slot :item="item" :item-index="index" ></slot>
     </template>
  </component>
</template>

<script>
  export default {
    name: "list-element",
    props:{
      component:{
        type:String,
        default:'draggable'
      },
      items:{
        type:Array,
        default:()=>[]
      },
    }
  }
</script>

<style scoped>

</style>
